export default __webpack_public_path__ + "static/media/3126.2db7dbda.jpg";